import React, {useContext} from 'react';
import "../styles/styles.css"
import Button from 'react-bootstrap/Button';
import ListGroup from 'react-bootstrap/ListGroup';
import { BsFileEarmarkPdf } from 'react-icons/bs';
import EnvCtx from "../contexts/EnvCtx";
import { useTranslation } from 'react-i18next'
import CameraCntx from "../contexts/CameraCntx";

const Cart = () => {
    const { cciaa } = useContext(EnvCtx);
    const { selectedIva, setSelectedIva, selectedMediazione, selectedLiteA, selectedLiteB, selectedTipoSpesaC, tipiSpesaA, spesaRaccomandata, listValoreA,
        totaleB, totaleC, totale, formatNumber, generatePdf, getDescrizioneByLingua, getDescrizioneLivelloByLingua} = useContext(CameraCntx);
    const { t } = useTranslation();

    const handleIvaButtonClick = (ivaOption) => {
        setSelectedIva(ivaOption);
    };

    return (
        <div className="cart-container">
            <div className="container d-flex justify-content-center">
                <div className="row">
                    <div className="col-md-6">
                        <div className="d-flex justify-content-between">
                            <div className={`border rounded p-1 mb-1 d-flex justify-content-center align-items-center cart-option-button ${selectedIva === 'IVA_inclusa' ? 'cart-option-selected' : 'cart-option-unselected'}`}
                                 onClick={() => handleIvaButtonClick('IVA_inclusa')} style={selectedIva === 'IVA_inclusa' ? { backgroundColor: cciaa ? cciaa.background_colore : "" } : {}}>{t("iva_inclusa")}
                            </div>
                            <div className={`border rounded p-1 mb-1 d-flex justify-content-center align-items-center cart-option-button ${selectedIva === 'IVA_esclusa' ? 'cart-option-selected' : 'cart-option-unselected'}`}
                                 onClick={() => handleIvaButtonClick('IVA_esclusa')} style={selectedIva === 'IVA_esclusa' ? { backgroundColor: cciaa ? cciaa.background_colore : "" } : {}}>{t("iva_esclusa")}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <h5 style={{ textAlign: 'left' }}>{t("cart_title")}</h5>
            <ListGroup id="cart-list-group">
                {selectedMediazione && (
                    <ListGroup.Item className="cart-list-group-item">{getDescrizioneByLingua(selectedMediazione).toLowerCase()}</ListGroup.Item>
                )}
                {selectedLiteA && (
                    <ListGroup.Item className="cart-list-group-item">{getDescrizioneLivelloByLingua(selectedLiteA)}</ListGroup.Item>
                )}
                {selectedLiteA && tipiSpesaA.map((tipo, index) => (
                    listValoreA.map((item, idx) => {
                        if (tipo.chiave === item.tipo) {
                            if (!/^raccomandata[A-Za-z]*$/.test(tipo.chiave)) {
                                return (
                                    <ListGroup.Item key={index} className="cart-list-group-item">
                                        {getDescrizioneByLingua(tipo)} € {selectedIva === "IVA_inclusa" ? formatNumber(item.valore.conIva) : formatNumber(item.valore.senzaIva)}
                                    </ListGroup.Item>
                                );
                            }
                            else {
                                return null;
                            }
                        }
                        return null;
                    })
                ))}
                {spesaRaccomandata > 0 && (
                    <ListGroup.Item className="cart-list-group-item">{t("spesaRaccomandata")} € {formatNumber(spesaRaccomandata)}</ListGroup.Item>
                )}
                {selectedLiteB &&(
                    <>
                        <ListGroup.Item className="cart-list-group-item">{getDescrizioneLivelloByLingua(selectedLiteB)}</ListGroup.Item>
                        {totaleB > 0 && (
                            <ListGroup.Item className="cart-list-group-item">{t("spesaB")} € {formatNumber(totaleB)}</ListGroup.Item>
                        )}
                    </>
                )}
                {selectedTipoSpesaC && totaleC > 0 && (
                    <ListGroup.Item className="cart-list-group-item">{getDescrizioneByLingua(selectedTipoSpesaC)} € {formatNumber(totaleC)}</ListGroup.Item>
                )}
            </ListGroup>
            {totale > 0 && (
                <div className="row mt-2 ms-1 me-1 align-items-center justify-content-between cart-total-container">
                    <div className="col-auto cart-total-amount"> € {formatNumber(totale)} </div>
                    <div className="col-auto cart-total-option">{selectedIva === "IVA_inclusa" ? t("iva_inclusa") : t("iva_esclusa")}</div>
                </div>
            )}
            {(selectedLiteA || selectedLiteB) && (
                <div className="col-md-3 text-left mt-1 w-100">
                    <Button className="cart-pdf-button" onClick={generatePdf} style={{backgroundColor : cciaa.background_colore}}><BsFileEarmarkPdf className="cart-pdf-logo" />{t("scarica_pdf")}</Button>
                </div>
            )}
        </div>
    );
}

export default Cart;